<div class="inner-container bg-white section-gap-lg">
    <div class="container">
      <div fxLayout='row wrap' fxLayoutAlign="center center">
        <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="80" fxFlex.lg="70" fxFlex.xl="70">
          <div fxLayout='row wrap' fxLayoutAlign="center center">
            <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50">
              <!-- <div class="form-img register-image">
              </div> -->
              <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="80" fxFlex.lg="70" fxFlex.xl="70" style="display: flex;">
                <!-- <div class="form-img sign-in-image">
                </div> -->
                <img src="/assets/images/gefrecon/Gefrecon.png" style="margin: auto;" >
              </div>
            </div>
            <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50">
              <mat-card class="register-form form-margin">
                <h4>{{'REGISTER.DETAILS' | translate}}</h4>
                <form [formGroup]="formUser" (ngSubmit)= "onSubmit()">
                    <div class="form-group mb-4">
                        <mat-form-field class="w-100">
                          <mat-label>{{'REGISTER.FIRST_NAME' | translate}}</mat-label>
                          <input matInput type="text" formControlName="name" required/>
                          <mat-error *ngIf="formUser.get('name').hasError('required')">{{'REGISTER.VALIDATORS.FIRST_NAME' | translate}}</mat-error>
                        </mat-form-field> 
                        <mat-form-field class="w-100">
                          <mat-label>{{'REGISTER.LAST_NAME' | translate}}</mat-label>
                          <input matInput type="text" formControlName="surname" required>
                          <mat-error *ngIf="formUser.get('surname').hasError('required')">{{'REGISTER.VALIDATORS.LAST_NAME' | translate}}</mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                          <mat-label>{{'REGISTER.USERNAME' | translate}}</mat-label>
                          <input matInput type="text" formControlName="username" required/>
                          <mat-error *ngIf="formUser.get('username').hasError('required')">{{'REGISTER.VALIDATORS.USERNAME' | translate}}</mat-error>
                          <mat-error *ngIf="formUser.get('username').hasError('minLength')">{{ 'REGISTER.USERNAME_CHARACTERES' | translate }}</mat-error>
                        </mat-form-field>   
                        <mat-form-field class="w-100">
                          <mat-label>{{'REGISTER.EMAIL' | translate}}</mat-label>
                          <input matInput type="email" formControlName="email" required>
                          <mat-error *ngIf="formUser.get('email').hasError('required')">{{'REGISTER.VALIDATORS.EMAIL' | translate}}</mat-error>
                          <mat-error *ngIf="formUser.get('email').hasError('email')">{{'REGISTER.VALIDATORS.EMAIL_FORMAT' | translate}}</mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                          <mat-label>{{'REGISTER.MOBILE_NUMBER' | translate}}</mat-label>
                          <input matInput formControlName="phoneNumber" required>
                          <mat-error *ngIf="formUser.get('phoneNumber').hasError('required')">{{'REGISTER.VALIDATORS.MOBILE_NUMBER' | translate}}</mat-error>
                       </mat-form-field>
                        <mat-form-field class="w-100">
                          <mat-label>{{'REGISTER.ENTER_PASSWORD' | translate}}</mat-label>
                          <input matInput type="password" formControlName="password" required>
                          <mat-error *ngIf="formUser.get('password').hasError('required')">{{'REGISTER.VALIDATORS.ENTER_PASSWORD' | translate}}</mat-error>
                          <mat-error *ngIf="formUser.get('username').hasError('minLength')">{{'REGISTER.VALIDATORS.ENTER_PASSWORD_LENGTH' | translate}}</mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                          <mat-label>{{'REGISTER.RETYPE_PASSWORD' | translate}}</mat-label>
                          <input matInput type="password" formControlName="repeatPassword" required (blur)="checkPassword()">
                        </mat-form-field> 
                        <span style="color: red; font-size: 10.5px;" *ngIf="errorPassword">{{ 'REGISTER.PASSWORD_NOT_EQUAL | translate' }}</span> 
                        <div class="w-100">
                          <mat-checkbox matInput  class="example-margin" formControlName="checked">
                            <span class="conditions" (click)="readConditions()">
                              {{ 'REGISTER.USE_CONDITIONS_1' | translate }}<br>{{ 'REGISTER.USE_CONDITIONS_2' | translate }} 
                            </span>
                          </mat-checkbox>
                        </div> 
                      </div>
                  <button color="accent" [disabled]="formUser.invalid && !getChecked" class="button-lg mb-3" mat-raised-button>{{'REGISTER.REGISTER' | translate}}</button>
                <div>{{'REGISTER.ALREADY_COUNT' | translate}} <a class="accent-color" >{{'REGISTER.SIGN_IN_BUTTON' | translate}}</a></div>
                </form>
              </mat-card>
              <div class="alert alert-success" *ngIf="isSignUpFailed">
                <span style="color: red; font-size: 10.5px">{{ 'REGISTER.ERROR_REGISTER' | translate }}</span> 
              </div>
              <div class="alert alert-success" *ngIf="sameUser">
                <span style="color: red; font-size: 10.5px">{{ 'REGISTER.ERROR_EXIST_USER' | translate }}</span> 
              </div>
              <div class="alert alert-success" *ngIf="!checked">
                <span style="color: red; font-size: 10.5px">{{ 'REGISTER.ACEPT_TERMS' | translate }}</span> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
